import { List, Map, Record } from 'immutable';
import { parseConfiguration, normalizeAd, extractMetadata, extractActiveFont } from 'Legacy/translator';
import { parseLayouts, normalizeLayout } from 'PreviewLegacy/translator';
import { reviveAdStates, reviveComponents, reviveKeyframes, reviveActiveFonts } from 'Records/revivers';
import { reviveAdStateContainers, reviveLayouts } from 'PreviewRecords/revivers';
import {
  ADSTATES,
  ADSTATE_CONTAINERS,
  LAYOUTS,
  COMPONENTS,
  KEYFRAMES,
  ASSETS,
  APP,
  METADATA,
  UI,
  FONTS,
} from 'SharedConstants/';

export const imageToBlob = (imageURL) => {
  const img = new Image();
  const c = document.createElement('canvas');
  const ctx = c.getContext('2d');
  img.crossOrigin = '';
  img.src = imageURL;
  return new Promise((resolve) => {
    img.onload = () => {
      c.width = img.naturalWidth;
      c.height = img.naturalHeight;
      ctx.drawImage(img, 0, 0);
      c.toBlob((blob) => {
        resolve(blob);
      }, 'image/png', 0.75);
    };
  });
};

export const getInitialFonts = (adData) => {
  const activeFonts = reviveActiveFonts(extractActiveFont(adData));
  return new Map({
    activeFonts,
    fonts: new Map(),
    fontWeights: new Map(),
    textEditMode: false,
  });
};

export const getInitialAppState = ({
  metadata = new Map(),
  adStates = new Map(),
  components = new Map(),
  keyframes = new Map(),
  layouts = new Map(),
  adStateContainers = new Map(),

}) => {
  const StateHistory = new Record({
    past: new List(),
    present: undefined,
    _lastInterestingPresent: undefined,
    future: new List(),
  });

  return new StateHistory({
    present: new Map({
      [METADATA]: new Map(metadata),
      ad: new Map({
        [ADSTATES]: adStates,
        [COMPONENTS]: components,
        [KEYFRAMES]: keyframes,
      }),
      preview: new Map({
        [LAYOUTS]: layouts,
        [ADSTATE_CONTAINERS]: adStateContainers,
      }),
    }),
  });
};

export const getInitialAppStateFromAdData = (adData, previewData = '') => {
  const metadata = extractMetadata(adData);
  const normalizedAdData = normalizeAd(parseConfiguration(adData));
  const normalizedLayoutData = normalizeLayout(parseLayouts(previewData));

  const components = reviveComponents(normalizedAdData.entities.components);
  const keyframes = reviveKeyframes(normalizedAdData.entities.keyframes);
  const adStates = reviveAdStates(normalizedAdData.entities.adStates);
  const adStateContainers = reviveAdStateContainers(normalizedLayoutData.entities.adStateContainers);
  const layouts = reviveLayouts(normalizedLayoutData.entities.layouts);

  return getInitialAppState({
    metadata,
    adStates,
    components,
    keyframes,
    layouts,
    adStateContainers,
  });
};

export const getInitialState = ({
  appState = getInitialAppState(),
  assets = new List(),
  ui = new Map(),
  fonts = new Map(),
}) => new Map({
  [ASSETS]: assets,
  [APP]: appState,
  [UI]: ui,
  [FONTS]: fonts,
});



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/utils/utils.js